import { render, staticRenderFns } from "./Spa.vue?vue&type=template&id=2de6a603&scoped=true&"
import script from "./Spa.vue?vue&type=script&lang=js&"
export * from "./Spa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de6a603",
  null
  
)

export default component.exports